module.exports = __webpack_public_path__ + "img/avatar.1c1a5c14.webp";